import { FC, ReactNode } from "react";
import { Flex } from "@chakra-ui/react";

interface Props {
  children: ReactNode;
}

export const BannerContainer: FC<Props> = ({ children }) => {
  return (
    <Flex justify="center" mb={{ base: 10, md: 8 }} w="full">
      <Flex
        align={{ base: "flex-start", md: "center" }}
        bg="th.yellow1"
        gap={{ base: 1, md: 2 }}
        justify="center"
        maxW="65.75rem"
        minH={6}
        px={{ base: 8, md: 2 }}
        py={2}
        w="full"
      >
        {children}
      </Flex>
    </Flex>
  );
};
